<template>
  <b-alert
    class="mb-10" 
    show 
    variant="success"
  >
    <button
      type="button"
      aria-label="Close"
      class="close"
      @click="clearMessage"
    >
      <div class="alert-close">
        <span aria-hidden="true">
          <i class="la la-close"></i>
        </span>
      </div>
    </button>
    <p class="pt-2">{{ message }}</p>
  </b-alert>
</template>

<script>
export default {
  name: "SuccessBox",

  props: [
    'message'
  ],

  methods: {
    clearMessage() {
      this.$emit('clear_message')
    }
  }
};
</script>
